
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CxSpinner',
  props: {
    loading: { type: Boolean, default: true },
    size: { type: Number, default: 16 },
    stroke1: { type: Number, default: 6 },
    stroke2: { type: Number, default: 3 },
    color1: { type: String, default: '#2d84d7' },
    color2: { type: String, default: '#bdbdbd' }
  },
  computed: {
    style1(): {
      height: string;
      width: string;
      border: string;
      'border-color': string;
      } {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
        border: `${this.stroke1}px solid`,
        'border-color': `${this.color1} ${this.color1} transparent transparent`,
      };
    },
    style2(): {
      height: string;
      width: string;
      border: string;
      'border-color': string;
      } {
      return {
        height: `${this.size - 2}px`,
        width: `${this.size - 2}px`,
        border: `${this.stroke2}px solid`,
        'border-color': `${this.color2} ${this.color2} transparent transparent`
      };
    }
  }
});
